import { render } from "./Refresher.vue?vue&type=template&id=5a2b3f2f"
import script from "./Refresher.vue?vue&type=script&lang=js"
export * from "./Refresher.vue?vue&type=script&lang=js"

import exportComponent from "/builds/uf-manage/mobile/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__